import ReactDOM from 'react-dom/client'
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from 'react-redux'

import { store, persistor } from './store'

import App from './App'

import { NotificationProvider } from "./context/NotificationContext";

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </PersistGate>
  </Provider>
)

if (process.env.REACT_APP_USE_MOCK == 'true') {
  const { worker } = require("./mocks/browser");
  worker.start({
    onUnhandledRequest: "warn",
  });
}